<template>
  <div class="animated fadeIn list-of-pr">
    <b-card>
      <div slot="header">List of Purchase Request (with Items) 
        <div class="card-header-actions">
          <b-form-radio-group  v-model="tblData.viewOption">
              <b-form-radio value="Header">View Header</b-form-radio>
              <b-form-radio value="Lines">View Line/Items</b-form-radio>
          </b-form-radio-group>                  

          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.requestno" placeholder="PR No.(% for wildcard)" style="width:17% !important;"></b-form-input>
              <b-input-group-prepend><span class="p-2">Barter </span></b-input-group-prepend>
              <b-form-select v-model="tblData.barter" :plain="true" :options="dataList.barter"></b-form-select>
              <b-input-group-prepend><span class="p-2">Request by &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" placeholder="Request by" style="width:22% !important;"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>MR/SR Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.mrequestno" placeholder="MR No.(% for wildcard)" ></b-form-input>
              <b-input-group-prepend><span class="p-2">Remark</span></b-input-group-prepend>
              <b-form-input v-model="tblData.remark" placeholder="PR Note/Remark" style="width:35% !important;"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
              <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
              <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuDimShow=true">
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Item Requested</label></b-input-group-prepend>
              <b-form-input v-model="tblData.uraian" placeholder="Item Name/Description" style="width:30% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2 ml-1">Category</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nmcategory" placeholder="Category/Group"></b-form-input>
            </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Status Approval </label></b-input-group-prepend>
            <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
            <b-input-group-prepend><span class="p-2">Progress </span></b-input-group-prepend>
            <b-form-select v-model="tblData.pr" :plain="true" :options="dataList.prProgress"></b-form-select>
            <b-input-group-prepend><span class="pt-2">Receiving</span></b-input-group-prepend>
            <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked"
        show-empty 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="showActionHistory(data.item)" href="#"  style="padding:0 !important;">Action Status</b-dropdown-item>
        </b-dropdown>
      </template>        
          <template v-slot:cell(requestno)="data">
            {{ data.item.requestno}}  <span v-if="data.item.barter==1" style="background-color:yellow;">&nbsp; (BARTER) &nbsp;</span>
          </template>
        <template v-slot:cell(requestdate)="data">
          {{ data.item.requestdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(wfcomplete)="data">
          {{ data.item.wfcomplete | moment("DD MMM YYYY hh:mm:ss") }}
        </template>
        <template v-slot:cell(itemname)="data">
            <div style="width:350px;"><strong>{{data.item.itemname}}</strong> <br>
                <pre>{{data.item.description}}</pre>                
            </div>
        </template>
        <template v-slot:cell(quantity)="data">
          {{data.item.quantity | numFormat('0.[00]')}} &nbsp; {{data.item.unitsize}}
        </template>
        <template v-slot:cell(qtyPO)="data">
          {{data.item.qtyPO | numFormat('0.[00]')}} &nbsp; {{data.item.unitsize}}
        </template>
        <template v-slot:cell(qtyReceived)="data">
          {{data.item.qtyReceived | numFormat('0.[00]')}} &nbsp; {{data.item.unitsize}}
        </template>
        <template v-slot:cell(actionstatus)="data">
                <span v-if="(data.item.actionstatus)"><b-link @click.stop="showActionHistory(data.item)">{{data.item.actionstatus}}</b-link></span>
                <span v-else >{{data.item.actionstatus}}</span>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>
        <template v-slot:cell(mrequestno)="data">
                <span v-if="(data.item.mrequestno)"><b-link @click.stop="getAttachment(data.item)">{{data.item.mrequestno}}  <i class="fa fa-paperclip"></i></b-link></span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestno" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestdate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.remark"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
              <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1"  @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal v-model="actionHistoryShow" header-bg-variant="primary"  title="Action History" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Purchase Req. No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestdate"  disabled></b-form-input>                                        
                    </b-input-group>
                </b-col>
            </b-row >    
            <b-input-group >
                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                <b-form-input v-model="model.remark" readonly></b-form-input>
            </b-input-group>
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="120px">Action Date</th>
                    <th >Comment</th>
                    <th width="100px">Action By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in actionHistory" :key="row.reqactionkey">
                    <td> {{row.actiondate | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>{{row.actiondtl}}</td>
                    <td>{{row.actionby}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

      </b-modal>
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="PR Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Requesition(PR)No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.iscomplete==0)">
                      <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                          <i class="fa fa-trash"></i>
                      </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

      <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
          <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
      </b-modal>        

  </div>
</template>
<style lang="scss">
  .list-of-pr {
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    pre {
        white-space: pre-wrap;       /* css-3 */
        white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
        white-space: -pre-wrap;      /* Opera 4-6 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
    }    

    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
  }
</style>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import lkuDim from "../lookup/lkuDim";
import task from "../../apis/task";
import pr from "../../apis/logistic_pr";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, lkuDim},
  data() {
    return {
      actionHistoryShow:false,
      actionHistory:[],   
      showAttachment: false,   
      attachmens:[],
      showFilter: false,
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      lkuDimShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      items: [],
      tblData: {
        viewOption:'Header',
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        tgl2:moment().format('YYYY-MM-DD'),        
        sortBy: 'requestdate',
        sortDesc: true,
        DimCol:'Dim1',outstand:'1'
      },
      limit:15,
      pagination:false,
      tblFields: [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "mrequestno",
            label: "Request# (MR)",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nextwf_username",
            label: "CS Appover MR Dept.",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          },
          {
            key: "po",
            label: "P.O Number",
            sortable: true
          }          
          ],
      dataList: {
        openStatus: dropdown.openClose,
        approvalStatus: dropdown.approvalStatus,
        prProgress : dropdown.prProgress   , 
        barter: dropdown.YesNoAll   
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.viewOption" : function(newval) {
      if (newval=='Header') {
        this.tblFields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "mrequestno",
            label: "Material Request#",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
       
          {
            key: "nextwf_username",
            label: "Final Appover MR Dept.",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "po",
            label: "P.O Number",
            sortable: true
          }          
        ];
      } else {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "itemname",
            label: "Request Item Name & Description",
            sortable: true
          },
          {
            key: "quantity",
            label: "Qty.Requested",
            sortable: true
          },
          {
            key: "qtyPO",
            label: "Qty.PO Release",
            sortable: true
          },
          {
            key: "qtyReceived",
            label: "Qty.Received",
            sortable: true
          },
          {
            key: "mrequestno",
            label: "Material Request#",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
       
          {
            key: "nextwf_username",
            label: "Final Appover MR Dept.",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "po",
            label: "P.O Number",
            sortable: true
          }          
        ];
      }
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      this.refresh();
    },
  },
  created: function(){
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
  },
  // sockets: {
  //   task_changed: function(data) {
  //     const ada = this.items.find(i=> i.requestkey==data.taskkey);
  //     if (ada) {
  //       this.refresh();
  //     }
  //   }
  // },
  methods: {
    onSelectedDim: function(_selected){
        // this.tblData.DimVal=_selected.kode;
        // this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.tblData.DimVal=`${_selected.nama.trim()}`;
        this.lkuDimShow=false;
    },
    data: async function() {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.prlist) {
            this.tblData[key] = filter.prlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.prlist.tgl1 || '';
          this.tblData.tgl2=filter.prlist.tgl2 || '';

          this.showFilter=filtered;
          delete filter.prlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await pr.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await pr.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },

    search() {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    clearFilter() {
        this.tblData.jasa=  '';
        this.tblData.uraian=  '';
        this.tblData.requestno=  '';
        this.tblData.createby=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.outstand=  '';
        this.tblData.barter=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'createby', 'nmcategory', 'remark', 'requestno','mrequestno', 'tgl1', 'tgl2', 'outstand', 'DimCol', 'DimColInfo', 'DimVal','isproject', 'barter'];
      let filtered = false;
      const prlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              prlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          prlist.page=this.tblData.page;
          prlist.limit=this.tblData.limit;
          prlist.sortBy=this.tblData.sortBy;
          prlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.prlist=prlist;
          this.$store.commit("filter", filter);
      }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    showActionHistory: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await pr.actionhistory(record);
        this.actionHistory=data;    
        this.actionHistoryShow=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }                
      }
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.requestkey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }                
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.requestkey);
                formData.append('tableName', 'order_request_header');
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.requestkey});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.requestkey});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
              // this.close();
      })
      .catch(err => {
      // An error occurred
      })                

    },      
    
    add(){
      const filter = this.$store.state.filter;
      filter.prlist=this.tblData;
      this.$store.commit("filter", filter);
      router.push({name :"logistic.prform"});
    },
    edit: function() {
        if (this.model.requestkey) {
          const filter = this.$store.state.filter;
          filter.prlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'logistic.prform', params: { requestkey: this.model.requestkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.requestkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
          await pr.remove(this.model);
          setTimeout(() => {
            this.refresh();            
          }, 200);
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    approvalConfirm: async function () {
        if (this.model.requestkey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.requestkey});
                this.approvalHistory=data;                
              } catch (error) {
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
              }
            }
            this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.requestkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await pr.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await pr.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.requestkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.requestkey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    print: async function()
    {
      if (this.model.requestkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.model.typePR = 'close'; 
              this.reportUrl= await pr.print(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await pr.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
